import React from "react";
import { Search, X } from "lucide-react";
import colors from "../../../colors/colors";

interface SearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  searchInputRef: React.RefObject<HTMLInputElement | null>;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  setSearchQuery,
  searchInputRef,
}) => (
  <div
    style={{
      padding: "12px 20px",
      borderBottom: `1px solid ${colors.border_glass}`,
    }}
  >
    <div style={{ position: "relative" }}>
      <Search
        size={14}
        style={{
          position: "absolute",
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          color: colors.gray_medium,
          pointerEvents: "none",
        }}
      />
      <input
        ref={searchInputRef}
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            setSearchQuery("");
            searchInputRef.current?.blur();
          }
        }}
        placeholder="Search properties..."
        className="edit-panel-search"
        style={{
          width: "100%",
          padding: "8px 30px 8px 32px",
          fontSize: "12px",
          border: `1px solid ${colors.border_glass}`,
          borderRadius: "10px",
          background: colors.bg_light,
          color: colors.primary,
          outline: "none",
          transition: "border-color 0.15s, box-shadow 0.15s",
          fontFamily: "inherit",
          boxSizing: "border-box",
        }}
      />
      {searchQuery && (
        <button
          onClick={() => {
            setSearchQuery("");
            searchInputRef.current?.focus();
          }}
          style={{
            position: "absolute",
            right: "6px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "2px",
            display: "inline-flex",
            alignItems: "center",
            color: colors.gray_medium,
          }}
        >
          <X size={12} />
        </button>
      )}
    </div>
  </div>
);
